import { useQuery } from '@tanstack/vue-query'
import { unref, type MaybeRef } from 'vue'
import { ownersQueryKeys } from '../propertyOwnersQueryKeys'
import { getOwnerBankAccountsLookup } from '../propertyOwnersEndpoints'

export function useOwnerBankAccountsQuery(ownerId: MaybeRef<string>) {
  return useQuery({
    queryKey: () => ownersQueryKeys.bankAccountsLookup(unref(ownerId)),
    queryFn: () => getOwnerBankAccountsLookup(unref(ownerId)),
    enabled: () => Boolean(unref(ownerId)),
    staleTime: 1000 * 60 * 5,
  })
}
